const { createSlice } = require("@reduxjs/toolkit");

const subSupplierSlice = createSlice({
  name: "subSupplier",
  initialState: {
    isSubSupplierCreateModalOpen: false,
    actionableSubSupplierId: null,
    isSubSupplierEditable: false,
    isDuplicateAction: false,
    subSupplierList: [],
    subSupplierDetails: null,
    showDiscardModal: false,
    deleteModal: false,
    allSubSupplierData: null,
    actionableSubSupplierItem: null,
    bulkDeleteModal: false,
    subSupplierCreateModalOpenFromOrderDetails: false,
    isUploadBulkOrderModalOpen: false,
  },

  reducers: {
    toggleIsSubSupplierCreateModalOpen: (state) => ({
      ...state,
      isSubSupplierCreateModalOpen: !state.isSubSupplierCreateModalOpen,
    }),
    toggleIsUploadBulkSubSupplierModalOpen: (state) => ({
      ...state,
      isUploadBulkSubSupplierModalOpen: !state.isUploadBulkSubSupplierModalOpen,
    }),
    toggleActionableSubSupplierId: (state, action) => ({
      ...state,
      actionableSubSupplierId: action.payload ?? null,
    }),
    toggleIsSubSupplierEditable: (state) => ({
      ...state,
      isSubSupplierEditable: !state.isSubSupplierEditable,
    }),
    toggleShowDiscardModal: (state) => ({ ...state, showDiscardModal: !state.showDiscardModal }),
    toggleDuplicateAction: (state) => ({ ...state, isDuplicateAction: !state.isDuplicateAction }),
    toggleSubSupplierDeleteModal: (state) => {
      state.deleteModal = !state.deleteModal;
    },
    toggleSubSupplierBulkDeleteModal: (state) => {
      state.bulkDeleteModal = !state.bulkDeleteModal;
    },
    setSubSupplierList: (state, action) => {
      if (action.payload.append) {
        return {
          ...state,
          subSupplierList: [action.payload.subSupplier, ...state.subSupplierList],
        };
      } else {
        return {
          ...state,
          subSupplierList: action.payload.subSupplierList,
        };
      }
    },
    setAllSubSupplierData: (state, action) => ({
      ...state,
      allSubSupplierData: action.payload ?? null,
    }),
    setSubSupplierDetails: (state, action) => ({
      ...state,
      subSupplierDetails: action.payload ?? null,
    }),
    setSubSupplierSliceState: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setActionableSubSupplierItem: (state, action) => ({
      ...state,
      actionableSubSupplierItem: action.payload ?? null,
    }),
    toggleSubSupplierCreateModalOpenFromOrderDetails: (state) => ({
      ...state,
      subSupplierCreateModalOpenFromOrderDetails: !state.subSupplierCreateModalOpenFromOrderDetails,
    }),
  },
});

export const {
  toggleIsSubSupplierCreateModalOpen,
  toggleIsUploadBulkSubSupplierModalOpen,
  toggleActionableSubSupplierId,
  toggleIsSubSupplierEditable,
  toggleShowDiscardModal,
  toggleDuplicateAction,
  toggleSubSupplierBulkDeleteModal,
  setSubSupplierList,
  setSubSupplierDetails,
  setSubSupplierSliceState,
  toggleSubSupplierDeleteModal,
  setAllSubSupplierData,
  setActionableSubSupplierItem,
  toggleSubSupplierCreateModalOpenFromOrderDetails,
} = subSupplierSlice.actions;
export default subSupplierSlice.reducer;
